import { stringToId } from "./srtringToId";
export var createFormFieldId = function createFormFieldId(_ref) {
  var id = _ref.id,
    label = _ref.label,
    _ref$trailing = _ref.trailing,
    trailing = _ref$trailing === void 0 ? '' : _ref$trailing;
  return id !== null && id !== void 0 ? id : "".concat(stringToId(label)).concat(trailing ? "-".concat(trailing) : '');
};